
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/area-personale",
      function () {
        return require("private-next-pages/area-personale/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/area-personale"])
      });
    }
  